export default import.meta.ROLLUP_FILE_URL__1r2JWaj7oGUrnkkeqfDxQ;